import React, { useState } from 'react';
import LayerControl from './LayerControl';
import StopeStatistics from './StopeStatistics';
import ObjectDetailsPage from './ObjectDetailsPage';

const UnifiedPanel = ({ 
  modelList, 
  layerVisibility, 
  onToggleVisibility,
  activePanel,
  onPanelChange,
  onClose,
  panelWidth,
  onWidthChange
}) => {
  const panels = {
    layers: {
      name: 'Layers',
      icon: '📋',
      component: LayerControl
    },
    information: {
      name: 'Information',
      icon: 'ℹ️', 
      component: ObjectDetailsPage
    },
    statistics: {
      name: 'Statistics', 
      icon: '📊',
      component: StopeStatistics
    }
  };

  const ActiveComponent = panels[activePanel]?.component;

  // Width options
  const widthOptions = [
    { value: 'default', label: 'Default' },
    { value: '25', label: '25%' },
    { value: '50', label: '50%' },
    { value: '75', label: '75%' },
    { value: '100', label: '100%' }
  ];

  // Get panel width class
  const getPanelWidthClass = () => {
    if (panelWidth === '25') return 'w-1/4';
    if (panelWidth === '50') return 'w-1/2';
    if (panelWidth === '75') return 'w-3/4';
    if (panelWidth === '100') return 'w-full';
    return 'w-full sm:w-80'; // default
  };

  return (
    <div className={`flex flex-col absolute top-0 left-0 bg-white border border-yellow-400 rounded-r-lg shadow-lg ${getPanelWidthClass()} h-full max-h-screen z-50`}>
      {/* Compact Navigation Tabs at the very top */}
      <div className="flex border-b border-gray-200 bg-gray-50">
        {Object.entries(panels).map(([key, panel], index) => (
          <React.Fragment key={key}>
            <button
              onClick={() => onPanelChange(key)}
              className={`flex-1 flex items-center justify-center px-2 py-1.5 text-xs font-medium transition-all duration-200 ${
                activePanel === key
                  ? 'bg-yellow-500 text-white'
                  : 'bg-gray-100 text-gray-600 hover:text-gray-800 hover:bg-gray-200'
              }`}
            >
              <span className="text-xs mr-1">{panel.icon}</span>
              <span className="text-xs">{panel.name}</span>
            </button>
            {index < Object.entries(panels).length - 1 && (
              <div className="w-px bg-gray-300"></div>
            )}
          </React.Fragment>
        ))}
        {/* Mobile close button */}
        <button
          onClick={onClose}
          className="sm:hidden px-2 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-200 border-l border-gray-300 bg-gray-100"
          title="Close panel"
        >
          <span className="text-sm">×</span>
        </button>
      </div>

      {/* Width Control Buttons - Only show for Information panel */}
      <div className="flex border-b border-gray-200 bg-gray-100 px-1 py-0.5">
        <div className="flex items-center gap-0.5 w-full">
          {widthOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => onWidthChange(option.value)}
              className={`flex-1 px-1 py-0.5 text-xs font-medium transition-all duration-200 ${
                panelWidth === option.value
                  ? 'bg-yellow-500 text-white'
                  : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
              }`}
              title={option.label}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Panel Content */}
      <div className="flex-1 overflow-hidden">
        {ActiveComponent && (
          <div className="h-full">
            {activePanel === 'layers' && (
              <LayerControl
                modelList={modelList}
                layerVisibility={layerVisibility}
                onToggleVisibility={onToggleVisibility}
              />
            )}
            {activePanel === 'statistics' && <StopeStatistics />}
            {activePanel === 'information' && <ObjectDetailsPage />}
          </div>
        )}
      </div>
    </div>
  );
};

export default UnifiedPanel;
